import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export type OpConfigItem = {
  label: string;
  show: boolean | (() => boolean);
  click?: (() => any) | string;
};

export const xDropdownOpProps = buildProps({
  config: {
    type: definePropType<OpConfigItem[]>(Array),
    default: () => [],
  },
  max: {
    type: Number,
    default: 2,
  },
});
export type XDropdownOpProps = ExtractPropTypes<typeof xDropdownOpProps>;
